import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form"
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Typography,
  Container
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Contexts
import LayoutContext from "../../context/layout/LayoutContext";
import AuthContext from "../../context/auth/AuthContext";

// Components
import Footer from "../layout/Footer";
import validator from 'validator'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Register = (props) => {

  const { handleSubmit, register, errors } = useForm();

  const classes = useStyles();
  const history = useHistory();

  const { setAlert } = useContext(LayoutContext);
  const { registerUser, user_error, error, clearErrors, isAuthenticated } =
    useContext(AuthContext);

  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [emailError, setEmailError] = useState({
    emailError: ""
  });

  const [passwordError, setPasswordError] = useState({
    passwordError: ""
  });

  const { name, email, password, confirmPassword } = user;

  const onChange = (e) => {
    if(e.target.name === "email") {
      setEmailError({...emailError, emailError: !validator.isEmail(e.target.value)})
    }
    if(e.target.name === 'confirmPassword') {
      setPasswordError({...passwordError, passwordError: !validator.equals(password, e.target.value)})
    }
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    if (email === "" || password === "") {
      setAlert("Please fill in all fields.", "error");
    } else if (emailError?.emailError) {
      setAlert("Email is in wrong format.", "error");
    } else if (passwordError?.passwordError) {
      setAlert("Password doesn't match.", "error");
    } else {

      const res = await registerUser({
        name,
        email,
        password,
      });

      if (res.status !== 200) {
        setAlert(res.data.message, "error")
      } else {
        history.push("/login")
      }
    }
  };

  useEffect(() => {
    if (user_error) {
      setAlert(error, "error");
      clearErrors();
    }
  }, [user_error]);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/");
      history.push("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (error) {
      setAlert(error, "error");
      clearErrors();
    }
  }, [error]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Register New User
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            id="name"
            name="name"
            label="Name"
            value={name}
            onChange={onChange}
            autoFocus
          />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            {...register('email',{
              required: "Email is required",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Please enter a valid email."
              }
            })}
            id="email"
            name="email"
            label="Email"
            value={email}
            onChange={onChange}
            error={Boolean(emailError?.emailError)}
          />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            type="password"
            id="password"
            name="password"
            label="Password"
            value={password}
            onChange={onChange}
            error={Boolean(passwordError?.passwordError)}
          />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            label="Confirm Password"
            value={confirmPassword}
            onChange={onChange}
            error={Boolean(passwordError?.passwordError)}
          />
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            className={classes.submit}
          >
            Register{" "}
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              {" "}
              <Link
                variant="body2"
                onClick={() => history.push("/register")}
              >
                Login User
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </form>{" "}
      </div>

      <Footer />
    </Container>
  );
};

export default Register;
